/**
 * User-facing dates in European day–month–year order (dd/MM/yyyy).
 * Uses date-fns — not Intl defaults (those can follow US MDY).
 */
import { format } from 'date-fns';
import { enGB } from 'date-fns/locale';

const L = { locale: enGB };

export function formatDisplayDate(input) {
  if (input == null || input === '') return '—';
  const dt = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(dt.getTime())) return '—';
  return format(dt, 'dd/MM/yyyy', L);
}

export function formatDisplayDateTime(input) {
  if (input == null || input === '') return '—';
  const dt = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(dt.getTime())) return '—';
  return format(dt, 'dd/MM/yyyy HH:mm', L);
}

/** e.g. "14:30" (24h) */
export function formatDisplayTime(input) {
  if (input == null || input === '') return '—';
  const dt = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(dt.getTime())) return '—';
  return format(dt, 'HH:mm', L);
}

/** e.g. "Sunday, 5 April 2026" */
export function formatDisplayWeekdayDate(input) {
  if (input == null || input === '') return '—';
  const dt = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(dt.getTime())) return '—';
  return format(dt, 'EEEE, d MMMM yyyy', L);
}

/** e.g. "Apr 2026" */
export function formatDisplayMonthYear(input) {
  if (input == null || input === '') return '—';
  const dt = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(dt.getTime())) return '—';
  return format(dt, 'MMM yyyy', L);
}

/** e.g. "April 2026" */
export function formatDisplayMonthLongYear(input) {
  if (input == null || input === '') return '—';
  const dt = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(dt.getTime())) return '—';
  return format(dt, 'MMMM yyyy', L);
}

/** e.g. "Sun 5 Apr" */
export function formatDisplayWeekdayShortDM(input) {
  if (input == null || input === '') return '—';
  const dt = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(dt.getTime())) return '—';
  return format(dt, 'EEE d MMM', L);
}

/** Month abbreviation only, e.g. "Apr" */
export function formatDisplayMonthShort(input) {
  if (input == null || input === '') return '—';
  const dt = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(dt.getTime())) return '—';
  return format(dt, 'MMM', L);
}
